import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CommonFunctionService } from '../Common/common-function.service';
import { ProductLedgers } from 'src/app/models/product-ledgers';
import { ViewProductDetails } from 'src/app/models/view-product-details';
import { VposProductAppView } from 'src/app/models/vpos-product-app-view';
import { ProductPrice } from 'src/app/models/product-price';
import { catchError, map } from 'rxjs';
@Injectable()
export class ProductService {

  constructor(private service: DataService,private http: HttpClient, private common:CommonFunctionService) {  }
  createProduct(data,email)
  {
  
    return this.service.create(environment.createProductUrl+"?Email="+email,data);
  
  
  }
  
  
  createProductPrice(data,email)
  {
  
    return this.service.create(environment.createProductPriceUrl+"?Email="+email,data);
  
  
  }

createProductLedgers(data,email)
{
  return this.service.create(environment.addquantityToProduct+"?Email="+email,data);
  
}

  GetProducts(data)
  {
    return this.http.get<ViewProductDetails>(environment.getProducts+"?MerchantKeyId="+data)  
    .pipe(map(response => response))
    .pipe(catchError(this.common.handleError));
  } 
  //Add Products in Coupon Page
  GetProductsforCoupons(data,CouponCode)
  {
    return this.http.get<VposProductAppView>(environment.getproductlistforAppliedCoupons+"?MerchantKeyId="+data+'&CouponCode='+CouponCode)  
    .pipe(map(response => response))
    .pipe(catchError(this.common.handleError));
  } 
//Add Coupons in Product Page
  GetCouponsforProduct(productcode,merchantKeyId)
  {
    return this.http.get<ProductLedgers>(environment.getAppliedCouponsforProduct+"?ProductCode="+productcode+'&MerchantKeyId='+merchantKeyId)  
    .pipe(map(response => response))
    .pipe(catchError(this.common.handleError));
  }
  // ViewProducts(data,email)
  // {
  //   return this.http.get(environment.ViewProduct+"?id="+data+"&Email="+email)  
  //   .map(response => response) .catch(this.common.handleError);
  // } 

GetProductPriceByProductId(data,email)
{

  return this.http.get<ProductPrice>(environment.getProductPriceByProductIdUrl+"?ProductId="+data+"&Email="+email)  
  .pipe(map(response => response))
  .pipe(catchError(this.common.handleError));
}
  UpdateProduct(id,data,email)
{
  return this.service.put(environment.updateProductUrl+"?id="+id+"&Email="+email,data)  
  .pipe(map(response => response))
    .pipe(catchError(this.common.handleError));



}
UpdateProductPrice(id,data,email)
{
  return this.service.put(environment.updateProductPriceUrl+"?id="+id+"&Email="+email,data)  
  .pipe(map(response => response))
    .pipe(catchError(this.common.handleError));


}
deleteProduct(data,email)
{
  return this.service.put(environment.deleteProductUrl+"?Email="+email,data)  
  .pipe(map(response => response))
  .pipe(catchError(this.common.handleError));


}
deleteProductPrice(data,email)
{
  return this.service.put(environment.deleteProductPriceUrl+"?Email="+email,data)  
  .pipe(map(response => response))
    .pipe(catchError(this.common.handleError));



}

AddCouponsToProductCode(data1,data2,data3,email)
{


  return this.service.create(environment.addCouponsToProductCodeUrl+'?CouponCodes='+data1+'&ProductCode='+data2+'&MerchantKeyId='+data3+'&Email='+email,{});
}


GetProductByProductId(data,merchantKeyId)
{
  return this.http.get<VposProductAppView>(environment.GetProductByProductId+'?ProductId='+data + '&merchantKeyId='+merchantKeyId);
}

GetProductByProductCode(data,merchantKeyId)
{
  return this.http.get<VposProductAppView>(environment.GetProductByProductCode+'?ProductCode='+data + '&merchantKeyId='+merchantKeyId);
}
//For FileUpload

FileUpload(data,email,merchantKeyId)
{
  return this.http.post(environment.UploadProductFile + '?email='+email+'&merchantKeyId='+merchantKeyId,data);
}

GetProductLedgers(ProductId,Email,MerchantKeyId)
{
  return this.http.get<ProductLedgers>(environment.GetProductLedgerUrl+'?ProductId='+ProductId +'&Email='+ Email+'&merchantKeyId='+MerchantKeyId);
}

}
